const news = () => {
    if ($(".news-detail").length) {
        $('.slider-img').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            dots: true,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        dots: false,
                    }
                }
            ]
        });
        $('.list-article').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            rows: false,
            arrows: true,
            dots: false,
            prevArrow: $('#prev-article'),
            nextArrow: $('#next-article'),
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
}

module.exports = news
